/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.NoBoxCRM {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class FormDialog extends NoboxEntityDialog<FormRow, any> {
        protected getFormKey() { return FormForm.formKey; }
        protected getIdProperty() { return FormRow.idProperty; }
        protected getLocalTextPrefix() { return FormRow.localTextPrefix; }
        protected getNameProperty() { return FormRow.nameProperty; }
        protected getService() { return FormService.baseUrl; }
        protected getDeletePermission() { return FormRow.deletePermission; }
        protected getInsertPermission() { return FormRow.insertPermission; }
        protected getUpdatePermission() { return FormRow.updatePermission; }

        protected form = new FormForm(this.idPrefix);
        //protected lblElm = `<label class="caption"></label>`;
        protected checkElm = `<input type="checkbox" class="editor mr-1 checkField" name="Show" title="Show" DataCheck>`;
        protected inpElm = `<div class="form-control bgCustom col text-ellipsis"><span>DataValue</span>DataRequired</div>`;
        protected CategoryElm = `<div class="form-control col text-ellipsis"><div class="chat-sap mx-0 py-0" style="margin: 2px 0;"><div class="chat-sap-meta" style="display: table-row;"><span><b style="color:#344357;">DataCategory :&nbsp;</b></span></div></div></div>`;
        protected btnSettings = `<a class="btn inplace-button settingsField" title="Settings"><b><i class="fa fa-cog"></i></b></a>`;
        protected btnDelete = `<a class="btn inplace-button deleteField" title="Delete"><b><i class="fa fa-trash"></i></b></a>`;
        protected btnUp = `<a class="btn inplace-button upField disabled" title="Move to top"><b><i class="fa fa-chevron-up"></i></b></a>`;
        protected btnDown = `<a class="btn inplace-button downField disabled" title="Move to bottom"><b><i class="fa fa-chevron-down"></i></b></a>`;
        protected btnInfo = `<a class="btn inplace-button" tabindex="0" data-toggle="tooltip" title="This field will only appear if the form type is Order and the product field is filled in"><b><i class="fa fa-info"></i></b></a>`;
        protected data: Array<form>;
        protected dataPayments: Array<formPayment>;
        protected dataFollowUp: Array<followUp>;
        protected isSetDefFollowUp: boolean = false;
        public isFormImport = false;
        public importCallback = (res: FormRow) => { }

        array_move(old_index, new_index) {
            if (new_index >= this.data.length) {
                var k = new_index - this.data.length + 1;
                while (k--) {
                    this.data.push(undefined);
                }
            }
            this.data.splice(new_index, 0, this.data.splice(old_index, 1)[0]);
            return this.data; // for testing
        };

        array_movePay(old_index, new_index) {
            if (new_index >= this.dataPayments.length) {
                var k = new_index - this.dataPayments.length + 1;
                while (k--) {
                    this.dataPayments.push(undefined);
                }
            }
            this.dataPayments.splice(new_index, 0, this.dataPayments.splice(old_index, 1)[0]);
            return this.dataPayments; // for testing
        };

        renderElm() {
            let frmData = this.form.Data.element;
            frmData.html("");
            var $this = this;
            if (this.data.length > 0) {
                this.data.forEach((yz, ind) => {
                    let elm = `<div class="field ${yz.settings.label} row px-4" data-index="${ind}">`;
                    if (yz.settings.field == "category") {
                        elm += this.CategoryElm.replace("DataCategory", yz.settings.label);
                        elm += this.btnSettings.replace("settingsField", "settingsCategory");
                    } else {
                        //elm += this.lblElm;
                        if (yz.id != 1 && yz.id != 2)
                            elm += this.checkElm.replace("DataCheck", `${yz.isShow ? "checked" : ""}`);
                        elm += this.inpElm.replace("DataValue", yz.settings.label).replace("DataRequired", yz.settings.required ? `&nbsp;<span class="text-danger">*</span>` : "");
                        if (yz.id == 9)
                            elm += this.btnInfo;
                        elm += this.btnSettings;
                    }
                    if (yz.id > 9)
                        elm += this.btnDelete;
                    if (ind != 0) {
                        elm += this.btnUp.replace("disabled", "");
                    } else {
                        elm += this.btnUp;
                    }

                    if (ind != this.data.length - 1) {
                        elm += this.btnDown.replace("disabled", "");
                    } else {
                        elm += this.btnDown;
                    }
                    elm += `</div>`
                    frmData.append(elm);
                    frmData.find(".upField").unbind("click");
                    frmData.find(".upField").on("click", function () {
                        let i = $(this).parent().attr("data-index");
                        $this.array_move(i, parseInt(i) - 1);
                        $this.renderElm();
                    });
                    frmData.find(".downField").unbind("click");
                    frmData.find(".downField").on("click", function () {
                        let i = $(this).parent().attr("data-index");
                        $this.array_move(i, parseInt(i) + 1);
                        $this.renderElm();
                    });
                    frmData.find(".deleteField").unbind("click");
                    frmData.find(".deleteField").on("click", function () {
                        let i = $(this).parent().attr("data-index");
                        $this.data.splice(parseInt(i), 1);
                        $this.renderElm();
                    });
                    frmData.find(".settingsField").unbind("click");
                    frmData.find(".settingsField").on("click", function () {
                        let i = $(this).parent().attr("data-index");
                        let dlg = new FormSettingsDialog();
                        dlg.callback = (res: settingsForm) => {
                            $this.data[i].settings = res;
                            $this.renderElm();
                        }
                        dlg.config($this.data[i]);
                        dlg.loadEntityAndOpenDialog($this.data[i].settings);
                    });
                    frmData.find(".settingsCategory").unbind("click");
                    frmData.find(".settingsCategory").on("click", function () {
                        let i = $(this).parent().attr("data-index");
                        let dlg = new FormSettingCategoryDialog();
                        dlg.callback = (res: settingsForm) => {
                            $this.data[i].settings = res;
                            $this.renderElm();
                        }
                        dlg.loadEntityAndOpenDialog($this.data[i].settings);
                    });
                    frmData.find(".checkField").unbind("click");
                    frmData.find(".checkField").on("change", function () {
                        let i = $(this).parent().attr("data-index");
                        $this.data[i].isShow = $(this).is(":checked");
                        $this.renderElm();
                    });
                })

                frmData.append(`<div class="field Add" style="float: right;gap: 3px;"><div class="btn btn-primary addCategory">Add Category</div><div class="btn btn-primary addCustomField">Add Custom Field</div></div>`);
                frmData.find(".addCustomField").unbind("click");
                frmData.find(".addCustomField").on("click", function () {
                    let dlg = new FormSettingsDialog();
                    dlg.callback = (res: settingsForm) => {
                        $this.data.push({ id: Math.floor(Math.random() * 1000) + 9, isShow: true, settings: res } as form);
                        $this.renderElm();
                    }
                    dlg.configNew(null);
                    dlg.loadNewAndOpenDialog();
                });
                frmData.find(".addCategory").unbind("click");
                frmData.find(".addCategory").on("click", function () {
                    let dlg = new FormSettingCategoryDialog();
                    dlg.callback = (res: settingsForm) => {
                        $this.data.push({ id: Math.floor(Math.random() * 1000) + 9, isShow: true, settings: res } as form);
                        $this.renderElm();
                    }
                    dlg.loadNewAndOpenDialog();
                });
                NioApp.BS.tooltip('[data-toggle="tooltip"]');
            }
        }

        renderLayout(id: number) {
            this.form.Layout.element.html(`<div>
                                            <ul class="custom-control-group">
                                                <li class="text-center">
                                                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                                                        <input type="radio" class="custom-control-input" name="layoutRadio" id="layoutRadio1" ${id == 1 || this.isNew() ? "checked" : null} value="1">
                                                        <label class="custom-control-label p-2" for="layoutRadio1">
                                                            <div class="sidePanel"></div>
                                                            <div class="ml-1 contentPanel"></div>
                                                        </label>
                                                    </div>
                                                </li>
                                                <li class="text-center">
                                                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                                                        <input type="radio" class="custom-control-input" name="layoutRadio" id="layoutRadio2" ${id == 2 ? "checked" : null} value="2">
                                                        <label class="custom-control-label p-2" for="layoutRadio2">
                                                            <div class="contentPanel"></div>
                                                            <div class="ml-1 sidePanel"></div>
                                                        </label>
                                                    </div>
                                                </li>
                                                <li class="text-center">
                                                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                                                        <input type="radio" class="custom-control-input" name="layoutRadio" id="layoutRadio3" ${id == 3 ? "checked" : null} value="3">
                                                        <label class="custom-control-label p-2" for="layoutRadio3">
                                                            <div class="fullPanel"></div>
                                                        </label>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>`);
        }

        renderButton(param: string) {
            var data = { bg: 1, txt: "Order now" }
            if (!Q.isEmptyOrNull(param)) {
                data = JSON.parse(param);
            }
            this.form.Bbg.element.html(`<div class="col-lg-12 mt-1 px-1">
                                            <ul class="custom-control-group">
                                                <li>
                                                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                                                        <input type="radio" class="custom-control-input" name="buttonBgRadio" id="buttonBgRadio1" value="1" ${data.bg == 1 || this.isNew() ? "checked" : null}>
                                                        <label class="custom-control-label p-2 bg-primary" for="buttonBgRadio1">
                                                        </label>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                                                        <input type="radio" class="custom-control-input" name="buttonBgRadio" id="buttonBgRadio2" value="2" ${data.bg == 2 ? "checked" : null}>
                                                        <label class="custom-control-label p-2 bg-success" for="buttonBgRadio2">
                                                        </label>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                                                        <input type="radio" class="custom-control-input" name="buttonBgRadio" id="buttonBgRadio3" value="3" ${data.bg == 3 ? "checked" : null}>
                                                        <label class="custom-control-label p-2 bg-warning" for="buttonBgRadio3">
                                                        </label>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                                                        <input type="radio" class="custom-control-input" name="buttonBgRadio" id="buttonBgRadio4" value="4" ${data.bg == 4 ? "checked" : null}>
                                                        <label class="custom-control-label p-2 bg-danger" for="buttonBgRadio4">
                                                        </label>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>`)
            this.form.Btxt.value = data.txt;
        }

        renderHeader(param: string) {
            var data = { t: "", isT: false, d: "", isD: false };
            if (!Q.isEmptyOrNull(param)) {
                data = JSON.parse(param);
                if (data.d == undefined)
                    data.d = "";
                if (data.t == undefined)
                    data.t = "";
            }
            this.form.HData.element.html("");
            var rTitle = !data.isT ? "readonly" : null;
            var rDesc = !data.isD ? "readonly" : null;
            var elmTitle = `<div class="field HTitle px-0">
                                <label class="caption" title="Title">Title</label>
                                <input type="checkbox" class="editor mr-1 checkHTitle" name="Show" title="Show" ${data.isT ? "checked" : null}>
                                <input type="text" class="editor s-Serenity-StringEditor s-StringEditor ${rTitle} inputHTitle" ${rTitle} placeholder="Title" value="${data.t}"> </div>`
            var elmSubTitle = `<div class="field HDesc px-0">
                                <label class="caption" title="Description">Description</label>
                                <input type="checkbox" class="editor mr-1 checkHDesc" name="Show" title="Show" ${data.isD ? "checked" : null}>
                                <textarea class="editor s-Serenity-TextAreaEditor s-TextAreaEditor ${rDesc} inputHDesc" rows="5" ${rDesc} placeholder="Description">${this.isNew() ? "" : data.d}</textarea></div >`
            this.form.HData.element.append(elmTitle + elmSubTitle);
            $(".checkHTitle").on("change", function () {
                let value = $(this).is(":checked");
                let inp = $(".inputHTitle");
                if (value) {
                    inp.removeClass("readonly");
                    inp.removeAttr("readonly");
                } else {
                    inp.addClass("readonly");
                    inp.attr("readonly", "true");
                }
            });
            $(".checkHDesc").on("change", function () {
                let value = $(this).is(":checked");
                let inp = $(".inputHDesc");
                if (value) {
                    inp.removeClass("readonly");
                    inp.removeAttr("readonly");
                } else {
                    inp.addClass("readonly");
                    inp.attr("readonly", "true");
                }
            })
        }

        renderPayment() {
            this.form.Payment.element.html("");
            this.form.Payment.element.addClass("row px-1");
            var $this = this;
            if (this.dataPayments.length > 0) {
                this.dataPayments.forEach((yz, ind) => {
                    let elm = `<div class="field ${yz.name} col-md-4 col-sm-12" data-index="${ind}">`;
                    elm += this.checkElm.replace("checkField", "checkFieldPay").replace("DataCheck", `${yz.isShow ? "checked" : ""} data-id="${yz.id}"`);
                    elm += this.inpElm.replace("DataValue", yz.name).replace("DataRequired", "");
                    //elm += this.btnInfo.replace(" and the product field is filled in", "");
                    elm += `</div>`;
                    this.form.Payment.element.append(elm);

                    $(".checkFieldPay").unbind("click");
                    $(".checkFieldPay").on("change", function () {
                        let i = $(this).parent().attr("data-index");
                        let valEPay = $(this).is(":checked");
                        $this.dataPayments[i].isShow = valEPay;
                    });
                })
            }
            NioApp.BS.tooltip('[data-toggle="tooltip"]');
        }

        renderOptSendMail(entity: FormRow) {
            var objSendMail = {
                accId: null,
                toIdExt: null
            } as optAkun;

            var accMail = this.form.accMail;
            var toMail = this.form.toMail;
            if (!Q.isEmptyOrNull(entity.DataMail))
                objSendMail = JSON.parse(entity.DataMail) as optAkun;

            if (objSendMail.accId != null)
                accMail.set_value(`${objSendMail.accId}`);

            toMail.value = objSendMail.toIdExt;
        }

        renderOptSendWa(entity: FormRow) {
            var objSendWa = {
                accId: null,
                toIdExt: null
            } as optAkun;

            var accWa = this.form.accWa;
            var toWa = this.form.toWa;
            if (!Q.isEmptyOrNull(entity.DataWa))
                objSendWa = JSON.parse(entity.DataWa) as optAkun;

            if (objSendWa.accId != null)
                accWa.set_value(`${objSendWa.accId}`);

            toWa.value = objSendWa.toIdExt;
        }

        renderSuccessMsg(param: string, type: FormTypeEnum) {
            var data = {
                h: "Thank you",
                data: {
                    bank: "Order via Bank Transfer",
                    cod: "Order via COD",
                    epay: "Order via E-Payment",
                    basic: "Thank's for filled form"
                }
            }
            if (!Q.isEmptyOrNull(param) && this.isValidJSON(param)) {
                data = JSON.parse(param);
                this.form.SuccessData.value = data.h;
            }
        }

        renderSubFollowUp(arrFollowUpItem: followUpItem[], fl: followUp) {
            let elmChild = `<ul class="nav nav-tabs" id="followUpChildTab-${fl.id}" role="tablist">`;
            let elmChildContent = `<div class="tab-content" id="followUpChildTabContent-${fl.id}">`;
            arrFollowUpItem.map((dt, indDt) => {
                elmChild += `<li class="nav-item" role="presentation">
                                <button class="nav-link ${indDt == 0 ? "active" : ""}" id="child-${fl.id}-${dt.id}-tab" data-bs-toggle="tab" data-bs-target="#child-${fl.id}-${dt.id}-tab-pane"
                                    type="button" role="tab" aria-controls="child-${fl.id}-${dt.id}-tab-pane" aria-selected="${indDt == 0 ? "true" : ""}">${dt.title}</button>
                            </li>`
                elmChildContent += `<div class="tab-pane fade ${indDt == 0 ? "show active" : ""}" id="child-${fl.id}-${dt.id}-tab-pane" role="tabpanel" aria-labelledby="child-${fl.id}-${dt.id}-tab" tabindex="0">
                                            <input class="col-md-3 col-sm-12 mt-2 followupdataSelect p-0" data-textareaid="inp-child-${fl.id}-${dt.id}">
                                            <textarea class="mt-1 inpTextFollowUp" rows="8" id="inp-child-${fl.id}-${dt.id}" data-fl="${fl.id}" data-dt="${dt.id}">${dt.text}</textarea>
                                        </div>`;
            })
            elmChild += "</ul>"
            elmChildContent += "</div>"
            var hasil = elmChild + elmChildContent;
            return hasil;
        }

        renderFollowUp(listFollowUp: followUp[]) {
            var $this = this;
            let ind = listFollowUp.findIndex(c => c.id == 9);
            if (ind == 8) {
                // Remove the last element from the array
                let lastElement = listFollowUp.pop();
                // Add the last element to the beginning of the array
                listFollowUp.unshift(lastElement);
            }

            this.dataFollowUp = listFollowUp;
            var elmInduk = this.form.FollowUp.element;
            elmInduk.html("");
            var elmTab = `<ul class="nav nav-tabs" id="followUpTab" role="tablist">`;
            var elmTabContent = `<div class="tab-content" id="followUpTabContent">`;
            listFollowUp.forEach((fl, ind) => {
                elmTab += `<li class="nav-item" role="presentation">
                                <button class="nav-link ${ind == 0 ? "active" : ""}" id="induk-${fl.id}-tab" data-bs-toggle="tab" data-bs-target="#induk-${fl.id}-tab-pane"
                                    type="button" role="tab" aria-controls="induk-${fl.id}-tab-pane" aria-selected="${ind == 0 ? "true" : ""}">${fl.title}</button>
                            </li>`;
                elmTabContent += `<div class="tab-pane fade pt-2 ${ind == 0 ? 'show active' : ''}" id="induk-${fl.id}-tab-pane" role="tabpanel" aria-labelledby="induk-${fl.id}-tab" tabindex="0">
                                    ${this.renderSubFollowUp(fl.data, fl)}
                                </div>`
            })
            elmTab += `</ul>`;
            elmTabContent += `</div>`;
            elmInduk.append(elmTab + elmTabContent)
            elmInduk.append(`<div class="btn btn-primary resetFlUp my-1"><i class="fa fa-undo-alt pr-1"></i>Reset</div>`);
            elmInduk.find("input.followupdataSelect").each(function () {
                let elmSelect = new FormFollowUpVariableEditor($(this));
                elmSelect.change(() => {
                    let valSelect = elmSelect.get_value();
                    if (!Q.isEmptyOrNull(valSelect)) {
                        let idTextarea = $(this).attr("data-textareaid");
                        $this.setValueAtCursor($(`#${idTextarea}`), elmSelect.get_value())
                        elmSelect.set_value(null);
                    }
                })
            })
            $(".resetFlUp").unbind("click");
            $(".resetFlUp").on("click", () => {
                Q.confirm(`Are you sure to reset Follow Up messages for this template with Form Settings?`, async () => {
                    let frmSetting = $("#formSettingData").val();
                    if (frmSetting) {
                        this.dataFollowUp = JSON.parse(JSON.parse(frmSetting).FollowUp);
                    } else {
                        await Q.serviceCall({
                            blockUI: true,
                            url: "/services/" + FormService.baseUrl + "/Retrieve",
                            request: {
                                EntityId: 0,
                            },
                            onSuccess: (res: Serenity.RetrieveResponse<FormRow>) => {
                                this.dataFollowUp = JSON.parse(res.Entity.FollowUp);
                            }
                        })
                    }
                    this.isSetDefFollowUp = true;
                    this.applyChangesButton.click();
                });
            });
        }

        setValueAtCursor(textarea, value) {
            // Get cursor position
            var cursorPos = textarea.prop("selectionStart");

            // Get current textarea value
            var currentText = textarea.val();

            // Set the new value at the cursor position
            var newText = currentText.slice(0, cursorPos) + value + currentText.slice(cursorPos);

            // Update textarea value
            textarea.val(newText);

            // Move the cursor to the end of the inserted text
            textarea.prop("selectionStart", cursorPos);
            textarea.prop("selectionEnd", cursorPos + value.length);

            textarea.focus();
        }

        constructor() {
            super();
            var initFile = false;
            this.form.Data.element.css("overflow-x", "hidden");
            this.form.Payment.element.css("overflow-x", "hidden");
            this.form.Data.getGridField().css("overflow-x", "hidden");
            this.form.Payment.getGridField().css("overflow-x", "hidden");
            this.form.HLogo.element.parent().find("ul").on("DOMNodeInserted", function () {
                if (initFile == false) {
                    initFile = true;
                    $('ul li.file-item.file-image').each(function () {
                        var elIMage = $(this).find(".thumb ");
                        $(this).find(".thumb ").removeAttr("style");
                        $(this).find(".thumb ").css("overflow", "hidden");
                        var image = elIMage.attr("href");
                        elIMage.html(`<img src="${image}" style = "height: 100%;width: auto;overflow: hidden;margin:auto;" >`);
                    });
                    initFile = false;
                }
            });
        }
        protected updateInterface() {

            super.updateInterface();
            this.cloneButton.toggle(this.isEditMode());
            this.element.find(".btn-analytics").toggle(this.isEditMode());
            if (this.isFormImport) {
                this.saveAndCloseButton.on("click", () => {
                    var item = this.getSaveEntity();
                    this.importCallback(item);
                })
                this.applyChangesButton.hide();
                this.deleteButton.hide()
            }
        }

        save(callback?: (response: Serenity.SaveResponse) => void) {
            if (this.isFormImport) {
                if (this.validateForm()) {
                    this.importCallback(this.getSaveEntity());
                    this.dialogClose();
                }
            } else {
                super.save(callback)
            }
        }

        protected getCloningEntity() {
            var clone = super.getCloningEntity();
            var suffix = ' (Clone)';
            clone.Name = clone.Name + suffix;
            clone.HLogo = null;
            return clone;
        }

        getSaveEntity() {
            var $this = this;
            var entity = super.getSaveEntity();
            entity.Layout = $("input[name='layoutRadio']:checked").val();
            entity.HData = JSON.stringify({ t: $(".inputHTitle").val(), isT: $(".checkHTitle").is(":checked"), d: $(".inputHDesc").val(), isD: $(".checkHDesc").is(":checked") });
            entity.BData = JSON.stringify({ bg: $("input[name='buttonBgRadio']:checked").val(), txt: this.form.Btxt.value });
            entity.Data = JSON.stringify(this.data);
            entity.DataMail = JSON.stringify({ accId: this.form.accMail.get_value(), toIdExt: this.form.toMail.value } as optAkun);
            entity.DataWa = JSON.stringify({ accId: this.form.accWa.get_value(), toIdExt: this.form.toWa.value } as optAkun);
            entity.Payment = /*this.form.Type.get_value() == FormTypeEnum.Basic ? null :*/ JSON.stringify(this.dataPayments);

            if (!this.isSetDefFollowUp) {
                this.form.FollowUp.element.find("textarea.inpTextFollowUp").each(function () {
                    var data = $(this).data();
                    let objFl = $this.dataFollowUp.findIndex((yz) => yz.id == data.fl)
                    if (objFl != -1) {
                        let objFlItem = $this.dataFollowUp[objFl].data.findIndex((yz) => yz.id == data.dt)
                        if (objFlItem != -1)
                            $this.dataFollowUp[objFl].data[objFlItem].text = $(this).val();
                    }
                });
            }
            entity.FollowUp = JSON.stringify(this.dataFollowUp);
            if (this.dataFollowUp.length == 9) {
                let objFlUp = this.dataFollowUp.find(obj => obj.id == 9);
                if (objFlUp) {
                    entity.SuccessData = JSON.stringify({
                        h: this.form.SuccessData.value,
                        data: {
                            basic: objFlUp.data[0].text,
                            bank: objFlUp.data[1].text,
                            cod: objFlUp.data[2].text,
                            epay: objFlUp.data[3].text
                        }
                    })
                }
            }

            if (this.form.VideoUrl.value.includes("</iframe>")) {
                entity.VideoUrl = $(this.form.VideoUrl.value).attr("src");
            } else if (this.form.VideoUrl.value.includes("youtube") && !this.form.VideoUrl.value.includes("/embed/")) {
                entity.VideoUrl = `https://www.youtube.com/embed/${this.getYouTubeVideoId(this.form.VideoUrl.value)}`;
            } else if (this.form.VideoUrl.value.includes("vimeo") && !this.form.VideoUrl.value.includes("/video/")) {
                entity.VideoUrl = `https://player.vimeo.com/video/${this.getVimeoVideoId(this.form.VideoUrl.value)}`;
            }

            this.isSetDefFollowUp = false;

            return entity;
        }
        getVimeoVideoId(url) {
            // Menemukan ID video dalam URL Vimeo
            const match = url.match(/vimeo\.com\/(\d+)/);

            // Jika ID video ditemukan, kembalikan nilainya; jika tidak, kembalikan null
            return match ? match[1] : null;
        }
        getYouTubeVideoId(url) {
            // Menghapus karakter sebelum tanda pertanyaan (?)
            url = url.split('?')[1];

            // Membagi query string menjadi pasangan key-value
            const params = new URLSearchParams(url);

            // Mendapatkan nilai parameter 'v'
            const videoId = params.get('v');

            return videoId;
        }
        isValidJSON(jsonString) {
            try {
                JSON.parse(jsonString);
                return true;
            } catch (error) {
                return false;
            }
        }
        async loadEntity(entity: FormRow) {
            super.loadEntity(entity);

            if (entity)
                if (entity.Id == 1) {
                    this.deleteButton.remove();
                    this.form.ProductId.getGridField().toggle(false);
                    Serenity.EditorUtils.setReadOnly(this.form.Type, true);
                    if (entity.Type == FormTypeEnum.Basic) {
                        this.form.Type.set_value("2");
                        Q.serviceCall({
                            url: "/services/" + FormService.baseUrl + "/Update",
                            blockUI: true,
                            request: {
                                EntityId: entity.Id,
                                Entity: {
                                    Type: FormTypeEnum.Order
                                } as FormRow
                            }
                        })
                    }
                }

            var listFollowUp = [
                {
                    "id": 9,
                    "title": "Redirect",
                    "data": [
                        {
                            "id": 1,
                            "title": "Basic",
                            "text": "Thank you sis {customer_name} for filling out this form 🙏🏻"
                        },
                        {
                            "id": 2,
                            "title": "Bank Transfer",
                            "text": "Hello, I have placed an order for {products}, on behalf of {customer_name}. Please process it soon. 🙏🏻"
                        },
                        {
                            "id": 3,
                            "title": "COD",
                            "text": "Hello, I have placed an order for {products}, on behalf of {customer_name}. Please process it soon. 🙏🏻"
                        },
                        {
                            "id": 4,
                            "title": "E-Payment",
                            "text": "Hello, I have placed an order for {products}, on behalf of {customer_name}. Please process it soon. 🙏🏻"
                        }
                    ]
                },
                {
                    "id": 1,
                    "title": "Welcome",
                    "data": [
                        {
                            "id": 1,
                            "title": "Basic",
                            "text": "*Thank you, we have received your data with the following details*\n\n*Your Data:*\nName: {customer_name}\nPhone Number: {customer_phone}\nAddress: {customer_address}\nCountry: {customer_country}\nProvince: {customer_state}\nCity: {customer_city}"
                        },
                        {
                            "id": 2,
                            "title": "Bank Transfer",
                            "text": "*Thank you, we have received your order with the following details*\n\n{products}\n\n*Shipped to:*\nName: {customer_name}\nPhone Number: {customer_phone}\nAddress: {customer_address}\nCountry: {customer_country}\nProvince: {customer_state}\nCity: {customer_city}\n\nPlease Transfer to the Following Account: \n{bank_accounts}\n{order_id}\n\n*If you have transferred, please confirm so that we can process it immediately*"
                        },
                        {
                            "id": 3,
                            "title": "COD",
                            "text": "*Thank you, we have received your order with the following details*\n\n{products}\n\n*Shipped to:*\nName: {customer_name}\nPhone Number: {customer_phone}\nAddress: {customer_address}\nCountry: {customer_country}\nProvince: {customer_state}\nCity: {customer_city}\n\n*Is the address complete and correct? Please confirm, sis, so that we can immediately process the package for delivery.*"
                        },
                        {
                            "id": 4,
                            "title": "E-Payment",
                            "text": "*Thank you, we have received your order with the following details*\n\n{products}\n\n*Shipped to:*\nName: {customer_name}\nPhone Number: {customer_phone}\nAddress: {customer_address}\nCountry: {customer_country}\nProvince: {customer_state}\nCity: {customer_city}\n\n*To process your order, you can make the payment, OK, sis*, {e_payment_link}"
                        }
                    ]
                },
                {
                    "id": 2,
                    "title": "Order Detail",
                    "data": [
                        {
                            "id": 1,
                            "title": "Basic",
                            "text": "*Your Data:*\nName: {customer_name}\nPhone Number: {customer_phone}\nAddress: {customer_address}\nCountry: {customer_country}\nProvince: {customer_state}\nCity: {customer_city}"
                        },
                        {
                            "id": 2,
                            "title": "Bank Transfer",
                            "text": "*Your Order:*\n{products}\n\n*Shipped to:*\nName: {customer_name}\nPhone Number: {customer_phone}\nAddress: {customer_address}\nCountry: {customer_country}\nProvince: {customer_state}\nCity: {customer_city}\n\n*Please transfer {grand_total}, to one of the accounts below:*\n{bank_accounts}"
                        },
                        {
                            "id": 3,
                            "title": "COD",
                            "text": "*Your Order:*\n{products}\n\n*Shipped to:*\nName: {customer_name}\nPhone Number: {customer_phone}\nAddress: {customer_address}\nCountry: {customer_country}\nProvince: {customer_state}\nCity: {customer_city}\n\n*Sis, you can prepare {grand_total} and make sure the phone number and address are correct, sis*"
                        },
                        {
                            "id": 4,
                            "title": "E-Payment",
                            "text": "*Your Order:*\n{products}\n\n*Shipped to:*\nName: {customer_name}\nPhone Number: {customer_phone}\nAddress: {customer_address}\nCountry: {customer_country}\nProvince: {customer_state}\nCity: {customer_city}\n\n*To process your order, you can make the payment, OK, sis*, {e_payment_link}"
                        }
                    ]
                },
                {
                    "id": 3,
                    "title": "Follow Up 1",
                    "data": [
                        {
                            "id": 1,
                            "title": "Basic",
                            "text": "Thank you sis {customer_name} for filling out this form 🙏🏻"
                        },
                        {
                            "id": 2,
                            "title": "Bank Transfer",
                            "text": "Hello sis, for the items you ordered, we checked that payment has not been made yet.\nTo process your order, you can make the payment, bro 😊\n\nYou can make the payment to your account number:\n{bank_accounts}"
                        },
                        {
                            "id": 3,
                            "title": "COD",
                            "text": "Hello sis, please confirm whether the address is correct and complete for the COD package order? So that we can immediately send the package 😊 thank you."
                        },
                        {
                            "id": 4,
                            "title": "E-Payment",
                            "text": "Hello sis, for the items you ordered, we checked that payment has not been made yet.\nTo process your order, you can make the payment, bro 😊\n\nTo process your order, you can make the payment"
                        }
                    ]
                },
                {
                    "id": 4,
                    "title": "Follow Up 2",
                    "data": [
                        {
                            "id": 1,
                            "title": "Basic",
                            "text": "Thank you sis {customer_name} for filling out this form 🙏🏻"
                        },
                        {
                            "id": 2,
                            "title": "Bank Transfer",
                            "text": "Hello sis, good evening,\nTo process your order, you can make the payment, bro 😊\n\nYou can make the payment to your account number:\n{bank_accounts}"
                        },
                        {
                            "id": 3,
                            "title": "COD",
                            "text": "Hello sis, I want to confirm that the COD package order is ready to be shipped, please confirm, bro, is the address complete?"
                        },
                        {
                            "id": 4,
                            "title": "E-Payment",
                            "text": "Hello sis, good evening,\nTo process your order, you can make the payment, bro 😊\n\nTo process your order, you can make the payment"
                        }
                    ]
                },
                {
                    "id": 5,
                    "title": "Follow Up 3",
                    "data": [
                        {
                            "id": 1,
                            "title": "Basic",
                            "text": "Thank you sis {customer_name} for filling out this form 🙏🏻"
                        },
                        {
                            "id": 2,
                            "title": "Bank Transfer",
                            "text": "Hello sis, good evening,\nThe products you checked out have a few items left"
                        }
                    ]
                },
                {
                    "id": 6,
                    "title": "Processing",
                    "data": [
                        {
                            "id": 1,
                            "title": "Basic",
                            "text": "We have received data from {customer_name}, and we are currently processing your data."
                        },
                        {
                            "id": 2,
                            "title": "Bank Transfer",
                            "text": "We have received payment from {customer_name} for the purchase of {products} totaling {total_price}, we are now processing your order. 😊\n\nYou can make the payment to your account number:\n{bank_accounts}"
                        },
                        {
                            "id": 3,
                            "title": "COD",
                            "text": "We have received an order from {customer_name} for the purchase of {products} totaling {total_price}, and we are currently processing your order."
                        },
                        {
                            "id": 4,
                            "title": "E-Payment",
                            "text": "We have received payment from {suctomer_name} for the purchase of {products} totaling {total_price}, we are now processing your order. 😊\n\nTo process your order, you can make the payment"
                        }
                    ]
                },
                {
                    "id": 7,
                    "title": "Complete",
                    "data": [
                        {
                            "id": 1,
                            "title": "Basic",
                            "text": "Thank you sis {customer_name} for filling out this form 🙏🏻, I appreciate you"
                        },
                        {
                            "id": 2,
                            "title": "Bank Transfer",
                            "text": "Thank you sis {customer_name} for shopping at our store 🙏🏻, may the items last long and you will visit our store again"
                        },
                        {
                            "id": 3,
                            "title": "COD",
                            "text": "Thank you sis {customer_name} for shopping at our store 🙏🏻, may the items last long and you will visit our store again"
                        },
                        {
                            "id": 4,
                            "title": "E-Payment",
                            "text": "Thank you sis {customer_name} for shopping at our store 🙏🏻, may the items last long and you will visit our store again"
                        }
                    ]
                },
                {
                    "id": 8,
                    "title": "Up Selling",
                    "data": [
                        {
                            "id": 1,
                            "title": "Basic",
                            "text": "Thank you sis {customer_name} for filling out this form 🙏🏻"
                        },
                        {
                            "id": 2,
                            "title": "Bank Transfer",
                            "text": "Hello, we have a special promotion just for you {customer_name}\n\n- Product XYZ, from IDR 180,000 to only IDR 140,000 ☺\nLimited stock, order now before it runs out...️"
                        },
                        {
                            "id": 3,
                            "title": "COD",
                            "text": "Hello, we have a special promotion just for you {customer_name}\n\n- Product XYZ, from IDR 180,000 to only IDR 140,000 ☺\nLimited stock, order now before it runs out...️"
                        },
                        {
                            "id": 4,
                            "title": "E-Payment",
                            "text": "Hello, we have a special promotion just for you {customer_name}\n\n- Product XYZ, from IDR 180,000 to only IDR 140,000 ☺\nLimited stock, order now before it runs out...️"
                        }
                    ]
                }
            ] as Array<followUp>;
            var listPay = [
                {
                    id: 1,
                    name: "Bank Transfer",
                    isShow: true
                }, {
                    id: 2,
                    name: "COD",
                    isShow: false
                }, {
                    id: 3,
                    name: "E-Payment",
                    isShow: false,
                }
            ] as Array<formPayment>
            var listData = [
                {
                    id: 1,
                    //name: "Name",
                    isShow: true,
                    settings: {
                        field: "input",
                        inputType: "text",
                        required: true,
                        label: "Name",
                        placeHolder: "Your Name",
                        selectOpsi: null
                    } as settingsForm,
                }, {
                    id: 2,
                    //name: "Phone",
                    isShow: true,
                    settings: {
                        field: "input",
                        inputType: "number",
                        required: true,
                        label: "Phone",
                        placeHolder: "Phone/WhatsApp"
                    } as settingsForm,
                }, {
                    id: 3,
                    //name: "Phone 112",
                    isShow: false,
                    settings: {
                        field: "input",
                        inputType: "email",
                        required: false,
                        label: "Email",
                        placeHolder: "Your Email"
                    } as settingsForm,
                }, {
                    id: 9,
                    //name: "Phone 112",
                    isShow: true,
                    settings: {
                        field: "input",
                        inputType: "order",
                        required: true,
                        label: "Quantity",
                        placeHolder: "Quantity",
                        orderQuantity: "1,1,30"
                    } as settingsForm,
                }, {
                    id: 4,
                    //name: "Phone 112",
                    isShow: false,
                    settings: {
                        field: "input",
                        inputType: "text",
                        required: false,
                        label: "Note",
                        placeHolder: "Note"
                    } as settingsForm,
                }, {
                    id: 5,
                    //name: "Phone 112",
                    isShow: true,
                    settings: {
                        field: "textarea",
                        inputType: "",
                        required: true,
                        label: "Address",
                        placeHolder: "Address"
                    } as settingsForm,
                }, {
                    id: 6,
                    //name: "Phone 112",
                    isShow: false,
                    settings: {
                        field: "select",
                        inputType: "",
                        required: true,
                        label: "Country",
                        placeHolder: "Your Country",
                        selectOpsi: []
                    } as settingsForm,
                }, {
                    id: 7,
                    //name: "Phone 112",
                    isShow: false,
                    settings: {
                        field: "select",
                        inputType: "",
                        required: true,
                        label: "State",
                        placeHolder: "Your State",
                        selectOpsi: []
                    } as settingsForm,
                }, {
                    id: 8,
                    //name: "Phone 112",
                    isShow: false,
                    settings: {
                        field: "select",
                        inputType: "",
                        required: true,
                        label: "City",
                        placeHolder: "Your City",
                        selectOpsi: []
                    } as settingsForm,
                }
            ] as Array<form>;
            if (this.isNew()) {
                let frmSetting = $("#formSettingData").val();
                if (frmSetting) {
                    entity = JSON.parse($("#formSettingData").val());
                } else {
                    await Q.serviceCall({
                        blockUI: true,
                        url: "/services/" + FormService.baseUrl + "/Retrieve",
                        request: {
                            EntityId: 0,
                        },
                        onSuccess: (res: Serenity.RetrieveResponse<FormRow>) => {
                            entity = res.Entity;
                        }
                    })
                }
                if (entity.Type != null)
                    this.form.Type.set_value(entity.Type.toString());

                this.form.ShowLabel.value = entity.ShowLabel == 1 ? true : false;
                this.form.ShowCaptcha.value = entity.ShowCaptcha == 1 ? true : false;
                this.form.ShowCoupon.value = entity.ShowCoupon == 1 ? true : false;
                this.form.IsSendWa.value = entity.IsSendWa == 1 ? true : false;
                this.form.IsSendMail.value = entity.IsSendMail == 1 ? true : false;
                this.form.IsSendURL.value = entity.IsSendURL == 1 ? true : false;
                this.form.DataSendURL.value = entity.DataSendURL;
                this.form.SuccessType.value = entity.SuccessType.toString();

                if (this.isValidJSON(entity.Payment))
                    this.dataPayments = JSON.parse(entity.Payment);
                this.form.In.element.closest('.category').toggle(false);
                this.data = listData;

                this.element.find(".generate-qrcode").hide();
                this.element.find(".preview-form").hide();
                this.element.find(".embed-form").hide();
                this.element.find(".copy-url").hide();
            } else {
                this.form.In.element.closest('.category').toggle(true);
                this.data = Q.isEmptyOrNull(entity.Data) ? listData : JSON.parse(entity.Data);

                this.dataPayments = /*entity.Type == FormTypeEnum.Basic*/Q.isEmptyOrNull(entity.Payment) ? listPay : JSON.parse(entity.Payment);
                this.element.find(".generate-qrcode").show();
                this.element.find(".preview-form").show();
                this.element.find(".embed-form").show();
                this.element.find(".copy-url").show();
            }

            this.renderOptSendWa(entity);
            this.renderOptSendMail(entity);
            this.renderLayout(entity.Layout);
            this.renderHeader(entity.HData);
            this.renderElm();
            this.renderPayment();
            this.renderButton(entity.BData);
            this.renderSuccessMsg(entity.SuccessData, entity.Type);
            this.renderFollowUp(Q.isEmptyOrNull(entity.FollowUp) || !this.isValidJSON(entity.FollowUp) ? listFollowUp : JSON.parse(entity.FollowUp).length != 9 ? listFollowUp : JSON.parse(entity.FollowUp))

            this.onChangeType(entity.Type);
            this.form.Type.change(() => {
                let val = this.form.Type.get_value();
                this.onChangeType(val);
            })

            this.onChangeSuccessType(entity.SuccessType);
            this.form.SuccessType.change(() => {
                let val = this.form.SuccessType.get_value();
                this.onChangeSuccessType(val);
            });

            this.onChangeIsSendWa(entity.IsSendWa == 1 ? true : false);
            this.form.IsSendWa.change(() => {
                let val = this.form.IsSendWa.value;
                this.onChangeIsSendWa(val);
            })

            this.onChangeIsSendMail(entity.IsSendMail == 1 ? true : false);
            this.form.IsSendMail.change(() => {
                let val = this.form.IsSendMail.value;
                this.onChangeIsSendMail(val);
            })
            this.onChangeIsSendUrl(entity.IsSendURL == 1 ? true : false);
            this.form.IsSendURL.change(() => {
                let val = this.form.IsSendURL.value;
                this.onChangeIsSendUrl(val);
            })
        }

        onChangeType(val: FormTypeEnum) {
            if (this.get_entityId() != 1) {
                if (val == FormTypeEnum.Basic) {
                    this.form.ProductId.getGridField().toggle(false);
                    $("input[name=layoutRadio][value=3]").prop('checked', true);
                    this.form.Payment.element.closest('.category').toggle(false);
                } else {
                    this.form.ProductId.getGridField().toggle(true);
                    this.form.Payment.element.closest('.category').toggle(true);
                }
            }
        }
        onChangeIsSendWa(val: boolean) {
            if (!val) {
                this.form.accWa.set_readOnly(true);
                Serenity.EditorUtils.setReadonly(this.form.toWa.element, true);
                Serenity.EditorUtils.setRequired(this.form.toWa, false);
                Serenity.EditorUtils.setRequired(this.form.accWa, false);
            } else {
                this.form.accWa.set_readOnly(false);
                Serenity.EditorUtils.setReadonly(this.form.toWa.element, false);
                Serenity.EditorUtils.setRequired(this.form.toWa, true);
                Serenity.EditorUtils.setRequired(this.form.accWa, true);
            }
        }
        onChangeIsSendUrl(val: boolean) {
            if (!val) {
                Serenity.EditorUtils.setReadonly(this.form.DataSendURL.element, true);
                Serenity.EditorUtils.setRequired(this.form.DataSendURL, false);
            } else {
                Serenity.EditorUtils.setReadonly(this.form.DataSendURL.element, false);
                Serenity.EditorUtils.setRequired(this.form.DataSendURL, true);
            }
        }
        onChangeIsSendMail(val: boolean) {
            if (!val) {
                this.form.accMail.set_readOnly(true);
                Serenity.EditorUtils.setReadonly(this.form.toMail.element, true);
                Serenity.EditorUtils.setRequired(this.form.toMail, false);
                Serenity.EditorUtils.setRequired(this.form.accMail, false);
            } else {
                this.form.accMail.set_readOnly(false);
                Serenity.EditorUtils.setReadonly(this.form.toMail.element, false);
                Serenity.EditorUtils.setRequired(this.form.toMail, true);
                Serenity.EditorUtils.setRequired(this.form.accMail, true);
            }
        }
        onChangeSuccessType(val: FormSuccessTypeEnum) {
            let fldSuccess = this.form.SuccessData.getGridField();
            //this.form.SuccessData.value = null;
            if (val == FormSuccessTypeEnum.Page) {
                //this.form.SuccessDataContainer.getGridField().toggle(true);
                fldSuccess.children("label").html("<sup title='this field is required'>*</sup>Headline");
                fldSuccess.children("input").attr("placeholder", "ex: Thank's for your order");
            } else if (val == FormSuccessTypeEnum.Url) {
                //this.form.SuccessDataContainer.getGridField().toggle(false);
                fldSuccess.children("label").html("<sup title='this field is required'>*</sup>URL");
                fldSuccess.children("input").attr("placeholder", "ex: https://id.nobox.ai/");
            } else if (val == FormSuccessTypeEnum.Wa) {
                //this.form.SuccessDataContainer.getGridField().toggle(false);
                fldSuccess.children("label").html("<sup title='this field is required'>*</sup>Wa Number");
                fldSuccess.children("input").attr("placeholder", "ex: 62...");
            }
        }

        getButtonTitle(title: string): string {
            if ($(document).width() < 576) {
                return ``;
            } else {
                return `${title}`;
            }
        }

        protected getToolbarButtons() {
            var btn = super.getToolbarButtons();
            var $this = this;
            btn.push({
                cssClass: "generate-qrcode",
                hint: "Download QR Code",
                title: this.getButtonTitle("QR Code"),
                separator: true,
                icon: "fa-qrcode",
                visible: false,
                onClick: function () {
                    const qrCode = new QRCodeStyling({
                        width: 300,
                        height: 300,
                        margin: 10,
                        type: "svg",
                        data: `${window.location.origin}/form/${$("#dataUser").attr("data")}-${$this.get_entityId()}`,
                        image: "/Inbox/img/Icon Nobox v2.png",
                        //dotsOptions: {
                        //    color: "#4267b2",
                        //    type: "rounded"
                        //},
                        //backgroundOptions: {
                        //    color: "#e9ebee",
                        //},
                        dotsOptions: {
                            //color: "#007afe", sesuai logo
                            color: "#005fb1",
                            type: "rounded"
                        },
                        backgroundOptions: {
                            color: "#fff",
                        },
                        imageOptions: {
                            crossOrigin: "anonymous",
                            margin: 10
                        }
                    });

                    qrCode.append(document.getElementById("canvas"));
                    qrCode.download({ name: `${$this.get_entityId()}-${$this.get_entity().Name}`, extension: "png" });
                }
            });
            btn.push({
                cssClass: "preview-form",
                hint: "Preview",
                title: this.getButtonTitle("Preview"),
                icon: "fa-search",
                visible: false,
                onClick: function () {
                    window.open(`/form/${$("#dataUser").attr("data")}-${$this.get_entityId()}`)
                }
            });
            btn.push({
                cssClass: "btn-analytics",
                hint: "Analytics",
                title: this.getButtonTitle("Analytics"),
                icon: "fa-chart-bar text-danger",
                visible: true,
                onClick: () => {
                    window.open(`/Form/Analytics?form=${this.get_entityId()}`)
                }
            });

            btn.push({
                cssClass: "embed-form",
                hint: "Embed Form",
                title: this.getButtonTitle("Embed"),
                icon: "fa-code",
                visible: false,
                onClick: function () {
                    var text = `<iframe src="${window.location.origin}/form/${$("#dataUser").attr("data")}-${$this.get_entityId()}" width="100%" height="1000" frameborder="0" scrolling="yes"></iframe>`
                    navigator.clipboard.writeText(text);
                    Q.notifySuccess("Copied the embed succesfully.");
                }
            });
            btn.push({
                cssClass: "copy-url",
                hint: "Copy URL",
                title: this.getButtonTitle("Copy"),
                icon: "fa-copy",
                visible: false,
                onClick: function () {
                    var text = `${window.location.origin}/form/${$("#dataUser").attr("data")}-${$this.get_entityId()}`
                    navigator.clipboard.writeText(text);
                    Q.notifySuccess("Copied the url succesfully.");
                }
            });
            return btn;
        }
    }

    export interface optAkun {
        accId: number;
        toIdExt: string;
    }

    export interface selectOpsi {
        id: string;
        name: string;
        selected: boolean;
    }
    export interface settingsForm {
        field: string;
        inputType: string;
        selectOpsi: Array<selectOpsi>;
        required: boolean;
        label: string;
        placeHolder: string;
        orderQuantity: string;
        value: string;
    }
    export interface form {
        id: number;
        settings: settingsForm;
        isShow: boolean;
    }
    export interface formPayment {
        id: number;
        isShow: boolean;
        name: string;
        data: Array<opsiPayment>;
    }
    export interface opsiPayment {
        id: number;
        name: string;
        img: string;
        isShow: boolean;
    }

    export interface followUp {
        id: number;
        title: string;
        data: Array<followUpItem>
    }

    export interface followUpItem {
        id: number;
        title: string;
        text: string;
    }
}
